const firstLetterOfWord = (word: string) => word?.charAt(0)?.toLocaleUpperCase() || '';

export const getInitials = (firstName?: string, lastName?: string) => {
  return [firstLetterOfWord(firstName), firstLetterOfWord(lastName)].join('');
};

export const getFullName = (firstName?: string, lastName?: string) => {
  return [firstName, lastName].filter((a) => a).join(' ');
};
